module.exports = __webpack_public_path__ + "static/canisterSilver-400bcc5a63d5864a0d879c1976fd2645.jpg";